module.exports = __webpack_public_path__ + "static/media/096-question mark.4c4a46e2.svg";